import { isEmpty, isUndefined, findIndex, isArray } from 'lodash';
import { ISectionSchema } from "../components/Section";
import { IControlSchema } from "../components/Controls";

class RuleManagers {
  public run(sections: Array<ISectionSchema>, values: Array<{ controlId: string, value: any }>) : void {
    for (const section of sections) {
      const controls: Array<IControlSchema> = section.controls;
      this.round(controls, values)
    }
  }

  private getValue(controlId: string, values: Array<{ controlId: string, value: any }>): any {
    const index = findIndex(values, (x: any) => x.controlid === controlId);
    const value = index > -1 ? values[index].value : null;
    
    return value;
  }

  private round(controls: Array<IControlSchema>, values: Array<{ controlId: string, value: any }>) : void {
    for(const ctrl of controls) {
      if(ctrl.hasOwnProperty('controls')) {
        this.round(ctrl['controls'], values)
      }
      if (!isUndefined(ctrl.rule)) {
        const targetValue = this.getValue(ctrl.rule.controlTergetId, values);
        const rule = ctrl.rule;

        switch (rule.option) {
            //equal
            case 0: ctrl["visible"] = !isEmpty(targetValue) && ctrl.rule.value === targetValue;
                break;
            //not equal
            case 1: ctrl["visible"] = !isEmpty(targetValue) && ctrl.rule.value !== targetValue;
                break;
            //In
            case 2:
                if (isArray(targetValue) && Array.from(targetValue).every(t => t.hasOwnProperty('value') &&  t.hasOwnProperty('label'))) {
                  ctrl["visible"] =targetValue && 
                                  Array.from(targetValue).some((t: any) => t.value.toString() === ctrl.rule.value);
                } else {
                  ctrl["visible"] = !isEmpty(targetValue) && (ctrl.rule.value.indexOf(targetValue) > -1);
                }
                break;
            //not in
            case 3:
                ctrl["visible"] = !isEmpty(targetValue) && (ctrl.rule.value.indexOf(targetValue) === -1);
                break
            case 5:
                ctrl["visible"] =targetValue && 
                Array.from(targetValue).some((t: any) => t.value.toString() === ctrl.rule.value);
                break;
            //Panel checked
            case 7:
                ctrl["visible"] = !isEmpty(targetValue) && !isUndefined(targetValue.checked) && (
                  ((ctrl.rule.value === "1") && (targetValue.checked == true))
                  ||((ctrl.rule.value === "0") && (targetValue.checked == false)));
                break;
            //Dynamic grid selectKey
            case 9:
              if (isArray(targetValue) && Array.from(targetValue).every(t => t.hasOwnProperty('values'))) {
                  ctrl["visible"] = Array.from(targetValue).some(
                      (r:any) =>  (Array.from(r.values).some(
                        (t: any) => (t.hasOwnProperty('selectKey') && (t.selectKey == ctrl.rule.value)))));
              }
              break;
        }
      }

    }

  }

}
export default RuleManagers;



// WEBPACK FOOTER //
// ./src/services/RulesManager.ts